import React from 'react';
import {FullPageLoader} from '@ui/progress/full-page-loader';
import {Outlet, useParams} from 'react-router-dom';
import {useTitle} from '@app/titles/requests/use-title';
import {useRequest} from '@app/admin/requetes/requests/use-request';

export function EditRequestPage() {
  return <Outlet />;
}
